import React, { PropTypes } from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';
import { InputField, SpinnerButton } from 'components';
import { UserService, Utils } from 'frilans-finans';
import ModalContainer from '../../frilans-finans/modal/modal-container';
import CookieUtils from 'frilans-finans/utils/cookie-utils';

class PhoneNumberModal extends React.Component {

  static propTypes = {
    modalIsOpen: PropTypes.bool.isRequired
  }
  constructor (props) {
    super(props);

    this.state = {
      open: props.modalIsOpen,
      user: {
        cellphone: ''
      },
      showErrorWithoutBlur: false,
      posting: false
    };

    this.setPhoneNumber = this.setPhoneNumber.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setModalOpen = this.setModalOpen.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.clickSubmit = this.clickSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      open: nextProps.modalIsOpen
    });
  }

  setPhoneNumber (_, values) {
    this.setState({ user: { cellphone: values } });
  }

  clickSubmit (e) {
    e.preventDefault();

    this.setState({ showErrorWithoutBlur: true }, () => {
      if (Utils.validateInputValues(this.state.user)) {
        this.submitForm();
      }
    });
  }

  submitForm () {
    var params = Utils.getPostParams(this.state.user);
    UserService.update(params)
      .then(this.handleSuccess)
      .catch(this.handleError);

    this.setState({
      posting: true,
      userUpdated: false,
      postError: false
    });
  }

  handleSuccess () {
    this.setState({
      posting: false,
      open: false
    });
  }

  handleError () {
    this.setState({
      posting: false
    });
  }

  closeModal () {
    this.setModalOpen(false);
  }

  setModalOpen (value) {
    this.setState({
      open: value
    });

    if (!value) {
      CookieUtils.setHidePhoneNumberModalCookie();
    }
  }

  render = () => {
    return (
      <ModalContainer
        isOpen={this.state.open}
        callback={this.setModalOpen}
        title='MODAL_COMPLETE_INFORMATION'
        classes='complete-information-modal'
        shrink
      >
        <div className='form-row'>
          <InputField
            type='tel'
            name='cellphone'
            classes='wide'
            value={this.state.user.cellphone.value}
            placeholder={proxyCounterpart('TELEPHONE_NR')}
            callback={this.setPhoneNumber}
            required='true'
            minLength='8'
            errorMessage={proxyCounterpart('TELEPHONE_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur}
          />
        </div>
        <div className="new-modal-button-container">
          <button
            className='btn white no-border'
            onClick={this.closeModal}>
            <Translate content='CLOSE' />
          </button>
          <SpinnerButton
            text={proxyCounterpart('SAVE')}
            loading={this.state.posting}
            classes='btn'
            callback={this.submitForm}
            disabled={!this.state.user.cellphone.valid}
          />
        </div>
      </ModalContainer>
    );
  }
}

export default PhoneNumberModal;



/** WEBPACK FOOTER **
 ** ./src/components/phone-number-modal/phone-number-modal.js
 **/